import React from 'react';
import { useDraggable } from '@dnd-kit/core';

const StockCard = ({ itemId, builderId, price, shares, onUpdate, onRemove, isEditing, onStartEdit, onStopEdit, onCancelEdit }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `position-${builderId}-${itemId}`,
    data: {
      type: 'position',
      builderId,
      optionId: itemId,
      cardType: 'stock',
    },
    disabled: isEditing,
  });

  const handlePriceChange = (e) => {
    onUpdate('price', e.target.value);
  };

  const handleSharesChange = (e) => {
    onUpdate('shares', e.target.value);
  };

  const totalValue = (price * shares).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const style = transform
    ? { transform: `translate3d(${transform.x}px, ${transform.y}px, 0)` }
    : undefined;

  return (
    <tr ref={setNodeRef} style={style} className={isDragging ? 'position-row dragging' : 'position-row'}>
      <td>
        <button
          type="button"
          className="drag-handle"
          aria-label="Drag stock position"
          title={isEditing ? 'Save or cancel edits before dragging' : 'Drag to another combo'}
          disabled={isEditing}
          {...listeners}
          {...attributes}
        >
          ::
        </button>
        <span className="option-type stock">Stock</span>
      </td>
      <td>-</td>
      <td>-</td>
      <td>
        {isEditing ? (
          <input type="number" value={price} onChange={handlePriceChange} className="p-1 border rounded" />
        ) : (
          `$${Number(price).toFixed(2)}`
        )}
      </td>
      <td>
        {isEditing ? (
          <input type="number" value={shares} onChange={handleSharesChange} className="p-1 border rounded" step="1" />
        ) : (
          shares
        )}
      </td>
      <td>-</td>
      {/* Greeks for stock: delta = 1, gamma = 0, theta = 0, vega = 0 */}
      <td className="greeks-column">
        <div>
          <div><strong>Delta:</strong> {Number(1).toFixed(4)}</div>
          <div><strong>Gamma:</strong> {Number(0).toFixed(4)}</div>
          <div><strong>Theta:</strong> {Number(0).toFixed(4)}</div>
          <div><strong>V:</strong> {Number(0).toFixed(4)}</div>
        </div>
      </td>
      <td>${totalValue}</td>
      <td>
        {isEditing ? (
          <>
            <button onClick={onStopEdit} className="save-btn">
              Save
            </button>
            <button onClick={onCancelEdit} className="cancel-btn">
              Cancel
            </button>
          </>
        ) : (
          <button onClick={onStartEdit} className="edit-btn">
            Edit
          </button>
        )}
        <button onClick={onRemove} className="delete-btn">Delete</button>
      </td>
    </tr>
  );
};

export default StockCard;
